import React from 'react';

function ProfilePage(props) {
    var user = props.user || {};
    var votes = props.votes || [];
    var profileTab = props.profileTab || 'up';
    var canAdmin = !!props.canAdmin;
    var isLegacy = !!props.isLegacy;

    return React.createElement('div', { className: 'ddiv' },
      React.createElement('div', { className: 'container my-3' },
        React.createElement('div', { className: 'bb-profile-card' },
          React.createElement('div', { className: 'bb-profile-header' },
            React.createElement('div', { className: 'bb-profile-avatar' },
              user.avatar_url
                ? React.createElement('img', { src: user.avatar_url, alt: user.username })
                : React.createElement('div', { className: 'bb-profile-placeholder' }, (user.username || '?').charAt(0))
            ),
            React.createElement('div', null,
              React.createElement('div', { className: 'bb-profile-name' }, '@' + (user.username || 'discorduser')),
              React.createElement('div', { className: 'bb-profile-id' }, 'User ID: ' + user.id)
            ),
            React.createElement('div', { style: { marginLeft: 'auto', display: 'flex', alignItems: 'center' } },
              React.createElement('button', {
                className: 'bb-btn bb-btn-secondary bb-btn-xs',
                onClick: props.onLogout,
                style: { marginLeft: '0.5rem' }
              }, 'Logout')
            )
          ),
          React.createElement('div', { className: 'bb-profile-tabs ' },
            React.createElement('div', { className: 'bb-profile-tabs ' },
              React.createElement('button', {
                className: 'bb-filter-btn bb-filter-btn-sm' + (profileTab === 'up' ? ' active' : ''),
                onClick: function() { props.onTabChange('up'); }
              }, 'Upvotes'),
              React.createElement('button', {
                className: 'bb-filter-btn bb-filter-btn-sm' + (profileTab === 'down' ? ' active' : ''),
                onClick: function() { props.onTabChange('down'); }
              }, 'Downvotes'),
            ),
            canAdmin ? React.createElement('button', {
              className: 'bb-filter-btn bb-filter-btn-sm bb-filter-btn-orange bb-admin-toggle',
              onClick: function() { if (props.onAdminToggle) props.onAdminToggle(); },
            }, isLegacy ? 'Admin (lite)' : 'Admin') : null

          ),
          React.createElement('div', { className: 'bb-profile-table' },
            votes
              .filter(function(v) { return profileTab === 'up' ? v.vote_type === 'up' : v.vote_type === 'down'; })
              .map(function(v) {
                  var appMeta = (props.getAppMeta && typeof props.getAppMeta === 'function') ? props.getAppMeta(v.package_name) : null;
                  var appLabel = v.app_name || (appMeta ? (appMeta.app_name || v.package_name) : v.package_name);
                  var appIcon = v.icon_url || (appMeta ? appMeta.icon_url : '');
                var updated = v.updated_at ? v.updated_at.split('T')[0] : '';
                return React.createElement('div', { key: v.package_name, className: 'bb-profile-row' },
                  React.createElement('div', { className: 'bb-profile-row-main' },
                    React.createElement('div', { className: 'bb-profile-icon' },
                      appIcon
                        ? React.createElement('img', { src: appIcon, alt: appLabel })
                        : React.createElement('div', { className: 'bb-profile-placeholder' }, (appLabel || '?').charAt(0))
                    ),
                    React.createElement('div', { className: 'bb-profile-appname' }, appLabel)
                  ),
                  v.comment ? React.createElement('div', { className: 'bb-profile-comment' }, v.comment) : null,
                  React.createElement('div', { className: 'bb-profile-row-bottom' },
                    React.createElement('div', { className: 'bb-profile-meta' },
                      React.createElement('span', { className: 'bb-profile-vote-tag ' + (v.vote_type === 'up' ? 'up' : 'down') },
                        v.vote_type === 'up' ? 'Upvote' : 'Downvote'
                      ),
                      React.createElement('span', { className: 'bb-profile-date' }, updated || '')
                    ),
                    React.createElement('div', { className: 'bb-profile-actions' },
                      React.createElement('button', {
                        className: 'bb-btn bb-btn-secondary bb-btn-xs',
                        onClick: function() { props.onDelete(v.package_name); }
                      }, 'Remove')
                    )
                  )
                );
              })
          )
        )
      )
    );
}

export default ProfilePage;
